var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-100.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0091DA",
    cx: 21,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    fill: "#0091DA",
    x: 7,
    y: 20,
    width: 4,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,13.5 L30.5,18.7582534 C27.333449,21.2430863 24.1697111,22.5 21,22.5 C17.8302889,22.5 14.666551,21.2430863 11.5,18.7582534 L11.5,18.7582534 L11.5,13.5 L30.5,13.5 Z",
    stroke: "#FFFFFF",
    fill: "#0091DA"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#FFFFFF",
    fill: "#0091DA",
    points: "8 12.1512266 21 7 34 12.1512266 21 18"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 32.3847763,
    y: 11.8847763,
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,30 C9,32.209139 10.790861,34 13,34 L20,34 L20,34",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    fill: "#0091DA",
    x: 20.5,
    y: 32.5,
    width: 4,
    height: 3,
    rx: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatbot);
export default __webpack_public_path__ + "static/media/icon-chatbot.1f63b4958d8550b512af9933a92ed4ac.svg";
export { ForwardRef as ReactComponent };